<template>
  <v-container
    id="property-details"
    tag="section"
  >
    <property-detail-header
      v-if="propertyDetails"
      :property-details="propertyDetails"
      :event-data="zones.sensor"
    />
    <valkyrie-graph
      :property-id="$route.params.id"
      :property-type="propertyDetails.propertyType"
    />
    <v-row>
      <v-col>
        <v-card class="px-0 mx-8 mt-0">
          <v-tabs
            v-model="activeTab"
            background-color="transparent"
            color="muted"
          >
            <v-tabs-slider color="muted" />
            <valkyrie-tab
              v-for="(tab, i) in tabs"
              :id="`${tab.text}-tab`"
              :key="i"
              :icon="tab.icon"
              :text="tab.total ? `${tab.text} (${tab.total})` : tab.text"
            />
            <v-tabs-items
              v-model="activeTab"
              class="transparent"
            >
              <v-tab-item
                v-for="(tab, i) in tabs"
                :key="i"
                class="tab-window"
              >
                <keep-alive>
                  <div style="min-height: 200px">
                    <component
                      :is="`${tabs[activeTab].text}List`"
                      v-if="activeTab === i"
                      has-filters
                      :searchable="false"
                      :filter-by="'property_id'"
                      :filterable="false"
                    />
                  </div>
                </keep-alive>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ValkyrieGraph from '@/components/ValkyrieGraph.vue'
  import EventsList from '@/views/events/EventsList.vue'
  import SensorsList from '@/components/activityZones/ZoneThresholdList.vue'
  import propertyDetailRouterMixin from '@/helpers/property-details-router-mixin'
  import PropertyDetailHeader from '@/components/properties/PropertyDetailHeader'
  import ValkyrieTab from '@/components/base/ValkyrieTab'

  export default {
    name: 'PropertyDetails',
    components: {
      ValkyrieGraph,
      ValkyrieTab,
      EventsList,
      SensorsList,
      PropertyDetailHeader,
    },
    mixins: [propertyDetailRouterMixin],
    data: function () {
      return {
        activeTab: 0,
      }
    },
    computed: {
      ...mapGetters({
        propertyDetails: 'Properties/propertyDetails',
        zones: 'Properties/propertyDetails',
        eventListData: 'Events/eventsListPagination',
        activityZoneListData: 'ActivityZones/activityZonesListPagination',
      }),
      tabs () {
        return [
          {
            text: 'Sensors',
            icon: '$faTrafficCone',
            total: this.activityZoneListData ? this.activityZoneListData.total : '',
          },
          {
            text: 'Events',
            icon: '$faCalendarAlt',
            total: this.eventListData ? this.eventListData.total : '',
          },
        ]
      },
    },
    created () {
      const payload = {
        id: this.$route.params.id,
        type: 'properties',
      }
      this.$store.dispatch('Properties/fetchPropertyDetails', payload.id)
    },
  }
</script>
<style lang="scss">
#property-details {
  .tab-window {
    padding: 0 30px;
    margin-top: -2px;
    border-top: 2px solid #9797976c;
  }
  .v-tab--active {
      border-bottom: 2px solid $muted;
    }
  .v-tabs-items {
    .v-sheet.v-card:not(.v-sheet--outlined) {
      box-shadow: unset;
    }
  }
}
</style>
